import React, { useState, useEffect } from "react";
import { Button, Modal, Tabs, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import organizationsActions from "../../../redux/organizations/actions";
import userAction from "../../../redux/users/actions";
import { useProjectState } from "../../../context/stateContext";
import EditTabsGeneralSettings from "./AdminOrganizationEditTabs/EditTabsGeneralSettings";
import EditTabsMyMenuSettings from "./AdminOrganizationEditTabs/EditTabsMyMenuSettings";
import EditTabsOrderingSettings from "./AdminOrganizationEditTabs/EditTabsOrderingSettings";
import EditTabsDeliverySettings from "./AdminOrganizationEditTabs/EditTabsDeliverySettings";
import EditTabsPaymentsSetting from "./AdminOrganizationEditTabs/EditTabsPaymentsSettings";
import EditTabsRoomServiceSettings from "./AdminOrganizationEditTabs/EditTabsRoomServiceSettings";
import EditTabsAtonSettings from "./AdminOrganizationEditTabs/EditTabsAtonSettings";
import "./index.css";

const AdminOrganizationEditModal = ({ organization }) => {
  const dispatch = useDispatch();
  const { getMenuCategories } = userAction;
  const {
    updateOrganization,
    getOrganizationRestaurants,
    checkOrganizationConnectionRequest,
  } = organizationsActions;
  const { organizationRestaurants } = useSelector(
    (state) => state.organizationsReducer
  );
  const [generalSettings, setGeneralSettings] = useState([]);
  const [myMenuSettings, setMyMenuSettings] = useState([]);
  const [orderingSettings, setOrderingSettings] = useState([]);
  const [deliverySettings, setDeliverySettings] = useState([]);
  const [paymentsSettings, setPaymentsSettings] = useState([]);
  const [atonSettings, setAtonSettings] = useState([]);
  const [roomServiceSettings, setRoomServiceSettings] = useState([]);
  const [tabActiveKey, setTabActiveKey] = useState("1");
  const organizationId = organization?.id;
  const { openEditOrganizationModal, setOpenEditOrganizationModal } =
    useProjectState();

  useEffect(() => {
    if (
      openEditOrganizationModal === true &&
      organizationId !== undefined &&
      organizationId !== null
    ) {
      dispatch(getMenuCategories(organizationId));
      dispatch(getOrganizationRestaurants(organizationId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId, openEditOrganizationModal]);

  //GENERAL
  const {
    name,
    displayNameBulgarian,
    displayNameEnglish,
    note,
    city,
    touchSaleDatabaseSource,
    touchSaleDatabasePort,
    touchSaleDatabase,
    touchSaleDatabaseUserName,
    touchSaleDatabasePassword,
    atonDatabaseSource,
    atonDatabasePort,
    atonDatabase,
    atonDatabaseUserName,
    atonDatabasePassword,
    defaultTouchSaleRestaurantId,
    multipleRestaurants,
  } = generalSettings;

  // MYMENU
  const {
    modes,
    discountsEnabled,
    groupByOrderTime,
    showAllergensFilter,
    showAccount,
    geocodingEnabled,
    longtitude,
    latitude,
    radiusInMeters,
    textUpperCase,
    onlyRegisteredUsers,
    autoExpandCategories,
    favoriteItemsEnabled,
    autoExpandModifiers,
    menuItemsLayout,
    menuCategoriesMode,
    currency,
    defaultLanguage,
    supportedLanguages,
    rootCategoryId,
    marketingAgreementURL,
    termsOfUseUrl,
    privacyAndPolicyAgreementURL,
    logo,
    backgroundImage,
    advertBanner,
    mainColor,
    backgroundColor,
    headerFooterBackgroudColor,
    cardBackgroundColor,
    otherElementsColor,
    secondaryButtonColor,
    textColor,
    actionButtonTextColor,
    countryCode,
    reviewsEnabled,
    surveyEnabled,
    reviewUrl,
    workingHours,
    headerImageUrl,
  } = myMenuSettings;

  //Ordering
  const {
    orderingEnabled,
    paymentsEnabled,
    notifyWaiterEnabled,
    autoAcceptOrderEnabled,
    showNotifyWaiterButton,
    takeawayOptionEnabled,
    externalCategoriesUrl,
    defaultPriceListIds,
  } = orderingSettings;

  //Delivery
  const {
    deliveryEnabled,
    invoiceEnabled,
    headerDeliveryText,
    deliveryItemId,
    deliveryItemStationId,
    freeDeliveryTreshhold,
    estimatedDeliveryTimeMinutes,
    deliveryPrice,
    pickUpAddressBulgarian,
    pickUpAddressEnglish,
    autoAcceptOrdersCount,
    choosePaymentTypeEnabled,
  } = deliverySettings;

  //Payments
  const {
    paymentsConfigurationEnabled,
    paymentsConfigurationSplitBill,
    qrMenuLink,
    surveyUrl,
    minimumPaymentAmount,
    billLogo,
    receiptConfigurationHeader,
    receiptConfigurationFooter,
    payBillItemStatusThreshold,
  } = paymentsSettings;

  // Aton
  const { crmId, stockroom } = atonSettings;

  //RoomService
  const {
    roomServiceEnabled,
    roomDirectoryMyMenuText,
    roomDirectoryText,
    roomDirectoryFooterText,
    roomDirectoryUrl,
    footerImage,
  } = roomServiceSettings;

  const updateOrganiztionObject = {
    id: organizationId,
    name,
    displayNameBulgarian,
    displayNameEnglish,
    city,
    note,
    defaultTouchSaleRestaurantId:
      organizationRestaurants.length === 0 ? 1 : defaultTouchSaleRestaurantId,
    ...(touchSaleDatabaseSource !== null && { touchSaleDatabaseSource }),
    ...(touchSaleDatabasePort !== null && { touchSaleDatabasePort }),
    ...(touchSaleDatabase !== null && { touchSaleDatabase }),
    ...(touchSaleDatabaseUserName !== null && { touchSaleDatabaseUserName }),
    ...(touchSaleDatabasePassword !== null && { touchSaleDatabasePassword }),
    // Новите полета за Aton
    ...(atonDatabaseSource !== null && { atonDatabaseSource }),
    ...(atonDatabasePort !== null && { atonDatabasePort }),
    ...(atonDatabase !== null && { atonDatabase }),
    ...(atonDatabaseUserName !== null && { atonDatabaseUserName }),
    ...(atonDatabasePassword !== null && { atonDatabasePassword }),
    myMenuOrderingConfiguration: null, //
    myMenuDeliveryConfiguration: null, //
    myMenuPaymentConfiguration: null, //
    myMenuRoomServiceConfiguration: null, //
    multipleRestaurants: multipleRestaurants,

    myMenuConfiguration: {
      id: organizationId,
      rootCategoryId,
      modes:
        modes === "Ordering + Delivery"
          ? [1, 2]
          : Array.isArray(modes)
          ? modes
          : [modes],
      textUpperCase,
      groupByOrderTime,
      onlyRegisteredUsers,
      showAllergensFilter,
      autoExpandCategories,
      showAccount,
      favoriteItemsEnabled,
      autoExpandModifiers,
      menuItemsLayout,
      menuCategoriesMode,
      currency,
      defaultLanguage,
      languages: supportedLanguages,
      marketingAgreementURL,
      termsOfUseUrl,
      privacyAndPolicyAgreementURL,
      logo: `${logo?.substring(logo.indexOf(",") + 1)}`,
      backgroundImage: `${backgroundImage?.substring(
        backgroundImage.indexOf(",") + 1
      )}`,
      advertBanner:
        advertBanner !== null
          ? `${advertBanner?.substring(advertBanner.indexOf(",") + 1)}`
          : null,
      countryCode,
      reviewsEnabled,
      surveyEnabled,
      workingHours,
      reviewUrl,
      headerImageUrl,
      theme: {
        mainColor,
        backgroundColor,
        headerFooterBackgroudColor,
        cardBackgroundColor,
        otherElementsColor,
        secondaryButtonColor,
        textColor,
        actionButtonTextColor,
      },

      orderingConfiguration: {
        id: organizationId,
        orderingEnabled,
        paymentsEnabled,
        notifyWaiterEnabled,
        autoAcceptOrderEnabled,
        showNotifyWaiterButton,
        takeawayOptionEnabled,
        externalCategoriesUrl,
        defaultPriceListIds,
        geocodingEnabled,
        longtitude,
        latitude,
        radiusInMeters,
        discountsEnabled,
      },

      deliveryConfiguration: {
        id: organizationId,
        deliveryEnabled,
        invoiceEnabled,
        headerDeliveryText,
        deliveryItemId,
        deliveryItemStationId,
        freeDeliveryTreshhold,
        estimatedDeliveryTimeMinutes,
        deliveryPrice,
        pickUpAddressBulgarian,
        pickUpAddressEnglish,
        autoAcceptOrdersCount,
        choosePaymentTypeEnabled,
      },

      paymentConfiguration: {
        id: organizationId,
        paymentsEnabled: paymentsConfigurationEnabled,
        splitPaymentEnabled: paymentsConfigurationSplitBill,
        qrMenuLink,
        surveyUrl,
        minimumPaymentAmount,
        billLogo: billLogo?.substring(billLogo.indexOf(",") + 1),
        receiptConfiguration: {
          Header: receiptConfigurationHeader,
          Footer: receiptConfigurationFooter,
        },
        payBillItemStatusThreshold,
      },

      atonConfiguration: {
        id: organizationId,
        crmId,
        stockroom,
      },

      roomServiceConfiguration: {
        id: organizationId,
        roomServiceEnabled,
        roomDirectoryMyMenuText,
        roomDirectoryText,
        roomDirectoryFooterText,
        roomDirectoryUrl,
        footerImage,
      },
    },
  };

  const closeEditModal = () => {
    setOpenEditOrganizationModal(false);
  };
  const emptyInputsNotificationMessage = () => {
    if (modes.length === 0) {
      setTabActiveKey("2");
      return "Режим на работа е задължителен";
    }
  };
  const openEmptyInputsNotification = () => {
    notification["warning"]({
      message: emptyInputsNotificationMessage(),
    });
  };

  const editOrganization = () => {
    if (modes.length === 0) {
      openEmptyInputsNotification();
    } else {
      dispatch(updateOrganization(updateOrganiztionObject));
      setOpenEditOrganizationModal(false);
      setTabActiveKey("1");
    }
  };

  const saveGeneralState = (data) => {
    setGeneralSettings(data);
  };
  const saveMyMenuState = (data) => {
    setMyMenuSettings(data);
  };
  const saveOrderingState = (data) => {
    setOrderingSettings(data);
  };
  const saveDeliveryState = (data) => {
    setDeliverySettings(data);
  };

  const savePaymentsState = (data) => {
    setPaymentsSettings(data);
  };

  const saveAtonState = (data) => {
    setAtonSettings(data);
  };

  const saveRoomServiceState = (data) => {
    setRoomServiceSettings(data);
  };

  const organizationMode = Array.isArray(modes)
    ? modes?.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        null
      )
    : modes;

  const onCheckConnectionRequest = () => {
    dispatch(
      checkOrganizationConnectionRequest({
        Database: touchSaleDatabase,
        DatabasePassword: touchSaleDatabasePassword,
        DatabasePort: touchSaleDatabasePort,
        DatabaseSource: touchSaleDatabaseSource,
        DatabaseUserName: touchSaleDatabaseUserName,
      })
    );
  };

  const onCheckAtonConnectionRequest = () => {
    dispatch(
      checkOrganizationConnectionRequest({
        Database: atonDatabase,
        DatabasePassword: atonDatabasePassword,
        DatabasePort: atonDatabasePort,
        DatabaseSource: atonDatabaseSource,
        DatabaseUserName: atonDatabaseUserName,
      })
    );
  };

  const tabsItems = [
    {
      key: "1",
      label: "General",
      forceRender: true,
      children: (
        <>
          <EditTabsGeneralSettings
            sendGeneralState={saveGeneralState}
            organization={organization}
          />
        </>
      ),
    },
    {
      key: "2",
      forceRender: true,
      label: "MyMenu",
      children: (
        <>
          <EditTabsMyMenuSettings
            sendMyMenuState={saveMyMenuState}
            organization={organization}
          />
        </>
      ),
    },
    {
      key: "3",
      label: "Ordering",
      forceRender: true,
      disabled:
        organizationMode === 2 ||
        organizationMode === "Ordering + Delivery" ||
        (organizationMode === 3 &&
          organization?.myMenuConfiguration?.modes?.length === 2)
          ? false
          : true,

      children: (
        <>
          <EditTabsOrderingSettings
            sendOrderingState={saveOrderingState}
            organization={organization}
          />
        </>
      ),
    },
    {
      key: "4",
      label: "Delivery",
      forceRender: true,
      disabled:
        organizationMode === 1 ||
        organizationMode === "Ordering + Delivery" ||
        (organizationMode === 3 &&
          organization?.myMenuConfiguration?.modes?.length === 2)
          ? false
          : true,

      children: (
        <>
          <EditTabsDeliverySettings
            sendDeliveryState={saveDeliveryState}
            organization={organization}
            modes={modes}
          />
        </>
      ),
    },
    {
      key: "5",
      label: "Payments",
      forceRender: true,
      disabled:
        organizationMode === 0 ||
        organizationMode === 1 ||
        organizationMode === 2 ||
        organizationMode === "Ordering + Delivery" ||
        (organizationMode === 3 &&
          organization?.myMenuConfiguration?.modes?.length === 2)
          ? false
          : true,

      children: (
        <>
          <EditTabsPaymentsSetting
            sendPaymentsState={savePaymentsState}
            organization={organization}
          />
        </>
      ),
    },
    {
      key: "6",
      label: "RoomService",
      forceRender: true,
      disabled:
        organizationMode === 3 &&
        organization?.myMenuConfiguration?.modes?.length === 1
          ? false
          : true,

      children: (
        <>
          <EditTabsRoomServiceSettings
            sendRoomServiceState={saveRoomServiceState}
            organization={organization}
          />
        </>
      ),
    },
    {
      key: "7",
      label: "Aton",
      forceRender: true,

      children: (
        <>
          <EditTabsAtonSettings
            sendAtonState={saveAtonState}
            organization={organization}
          />
        </>
      ),
    },
    // EditTabsAtonSettings
  ];

  return (
    <>
      <Modal
        centered
        title={
          <>
            {organization?.name}
            <span className="admin-organization-modal-id">
              Id: {organization?.id}
            </span>
          </>
        }
        width={window.innerWidth > 760 ? "60%" : "95%"}
        open={openEditOrganizationModal}
        onCancel={closeEditModal}
        footer={[
          <div className="admin-organization-modal-footer-buttons-container">
            <div>
              <Button
                className="admin-organization-modal-footer-buttons"
                key="1"
                onClick={onCheckAtonConnectionRequest}
              >
                Провери Атон връзката
              </Button>
              <Button
                className="admin-organization-modal-footer-buttons"
                key="2"
                onClick={onCheckConnectionRequest}
              >
                Провери TouchSale връзката
              </Button>
            </div>
            <div>
              <Button
                className="admin-organization-modal-footer-buttons"
                key="3"
                onClick={closeEditModal}
              >
                Затвори
              </Button>
              <Button
                className="admin-organization-modal-footer-buttons"
                key="4"
                type="primary"
                onClick={editOrganization}
              >
                Запази
              </Button>
            </div>
          </div>,
        ]}
        okText="Запази"
        cancelText="Затвори"
      >
        <Tabs
          className="admin-organization-edit-modal-tabs"
          type="card"
          activeKey={tabActiveKey}
          items={tabsItems}
          onTabClick={(key) => {
            setTabActiveKey(key);
          }}
        />
      </Modal>
    </>
  );
};
export default AdminOrganizationEditModal;
